import { InlineLink } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { Container } from '@app/components/Container';
import { NoAppointmentsAvailable } from '@app/components/ScheduleInstallation';

import styles from './no-appointments.module.scss';

type NoAppointmentsProps = {
  navigateToPreviousPage: () => void;
};

export const NoAppointments = ({ navigateToPreviousPage }: NoAppointmentsProps) => {
  const { t } = useTranslation('ScheduleInstallation', {
    keyPrefix: 'NoAppointmentsAvailable',
  });

  const hrefLink = `tel:${t('phoneNumber')}`;

  const errorDescription = (
    <>
      {t('descriptionPartOne')}
      <InlineLink href={hrefLink}>{t('phoneNumber')}</InlineLink>
      {t('descriptionPartTwo')}
    </>
  );

  return (
    <Container>
      <NoAppointmentsAvailable
        className={styles['container']}
        navigateToPreviousPage={navigateToPreviousPage}
        description={errorDescription}
      />
    </Container>
  );
};
